// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__ghYBD","btnActive":"styles_btnActive__z-EpQ","actionDisable":"styles_actionDisable__opmRS","flex1":"styles_flex1__RBcTW"};